import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Calendar, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = `${BACKEND_URL}/api`;

const ShkrimeFetare = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchArticles();
  }, []);

  const fetchArticles = async () => {
    try {
      const res = await axios.get(`${API}/articles`);
      setArticles(res.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching articles:', error);
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <section className="py-16 md:py-24 bg-background">
        <div className="container mx-auto px-4 text-center">
          <p className="text-muted-foreground">Duke ngarkuar shkrimet fetare...</p>
        </div>
      </section>
    );
  }

  if (articles.length === 0) {
    return null;
  }

  const previewArticles = articles.slice(0, 3);

  return (
    <section id="shkrime" className="py-12 md:py-16 bg-background" data-testid="shkrime-fetare-section">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className="flex justify-between items-center mb-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary mb-3 flex items-center gap-3">
              <BookOpen className="w-7 h-7 text-accent" />
              Shkrime Fetare
            </h2>
            <p className="text-base text-muted-foreground">
              Artikuj dhe reflektime islame nga xhamia jonë
            </p>
          </motion.div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {previewArticles.map((article, index) => (
            <motion.div
              key={article.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-card rounded-xl shadow-sm p-4 hover:shadow-md transition-shadow flex flex-col h-full overflow-hidden"
            >
              <h3 className="font-heading font-semibold text-lg mb-2 text-foreground line-clamp-2 overflow-hidden text-ellipsis">
                {article.title}
              </h3>
              
              <p className="text-sm text-muted-foreground leading-relaxed mb-4 line-clamp-3 overflow-hidden text-ellipsis" 
                 dangerouslySetInnerHTML={{ __html: article.content }} />
                 
              <div className="mt-auto flex items-center justify-between">
                <div className="flex items-center gap-2 text-sm text-muted-foreground">
                  <Calendar className="w-4 h-4" />
                  <span>{new Date(article.created_at).toLocaleDateString('sq-AL')}</span>
                </div>
                
                <Link 
                  to={`/shkrime/${article.slug}`}
                  className="flex items-center gap-1 text-sm font-semibold text-accent hover:text-accent-700 transition-colors"
                >
                  Lexo më tepër
                  <ArrowRight className="w-4 h-4" />
                </Link>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="flex justify-center mt-8">
          <Link
            to="/artikuj"
            className="border border-emerald-800 text-emerald-800 px-6 py-2.5 rounded-lg font-medium hover:bg-emerald-800 hover:text-white transition-colors duration-200"
          >
            Shiko të gjithë artikujt →
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ShkrimeFetare;
